import { render, staticRenderFns } from "./AccessionEntry.vue?vue&type=template&id=b2cb816a&scoped=true&"
import script from "./AccessionEntry.vue?vue&type=script&lang=js&"
export * from "./AccessionEntry.vue?vue&type=script&lang=js&"
import style0 from "./AccessionEntry.vue?vue&type=style&index=0&id=b2cb816a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cb816a",
  null
  
)

export default component.exports